if (!customElements.get('td-kuya-buybox')) {
  class TdKuyaBuybox extends HTMLElement {
    connectedCallback() {
      this.waitlistTrigger = this.querySelector('[data-td-kuya-waitlist-trigger]');
      this.locatorLink = this.querySelector('[data-td-kuya-locator-scroll]');
      this.handleWaitlistClick = this.handleWaitlistClick.bind(this);
      this.handleLocatorClick = this.handleLocatorClick.bind(this);

      this.waitlistTrigger?.addEventListener('click', this.handleWaitlistClick);
      this.locatorLink?.addEventListener('click', this.handleLocatorClick);
    }

    disconnectedCallback() {
      this.waitlistTrigger?.removeEventListener('click', this.handleWaitlistClick);
      this.locatorLink?.removeEventListener('click', this.handleLocatorClick);
    }

    handleWaitlistClick() {
      const formId = this.waitlistTrigger?.getAttribute('data-td-kuya-waitlist-trigger');
      if (!formId) return;

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }

    handleLocatorClick(event) {
      const href = this.locatorLink?.getAttribute('href') || '';
      const target = href.startsWith('#') ? document.getElementById(href.slice(1)) : null;
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  customElements.define('td-kuya-buybox', TdKuyaBuybox);
}
